
import React from "react";
import { Button } from "@/components/ui/button";
import { History, Receipt } from "lucide-react";
import { useTranslation } from "react-i18next";

interface ClientSessionsModalHeaderProps {
  onViewHistory: () => void;
  onViewPaymentHistory: () => void;
}

const ClientSessionsModalHeader: React.FC<ClientSessionsModalHeaderProps> = ({
  onViewHistory,
  onViewPaymentHistory,
}) => {
  const { t } = useTranslation();

  return (
    <div className="flex-shrink-0 mb-6">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3">
        <h3 className="text-lg font-medium greek-text">
          {t('clients.sessionsTitle')}
        </h3>
        <div className="flex gap-2 flex-wrap">
          <Button
            variant="outline"
            size="sm"
            onClick={onViewHistory}
            className="flex items-center gap-2"
          >
            <History className="h-4 w-4" />
            {t('sessions.viewHistory')}
          </Button>
          <Button
            variant="outline"
            size="sm"
            onClick={onViewPaymentHistory}
            className="flex items-center gap-2"
          >
            <Receipt className="h-4 w-4" />
            {t('clients.paymentHistory')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ClientSessionsModalHeader;
